module.exports = __webpack_public_path__ + "static/media/request.6af77ec4.svg";